module.exports = __webpack_public_path__ + "static/Fabrice-08828c81c2a204731077043f89caf999.png";